<template>
  <FullScreenModal :open="open" @close="$emit('close')">
    <div>
      <SearchSelector
        id="organizationId"
        name="organizationId"
        :label="t('organization_label')"
        :options="organizations"
        :modelValue="organizationId"
        :defaultOptionText="t('organization_placeholder')"
        :searchPlaceholder="t('organization_search_placeholder')"
        required
        data-test="organization-selector"
        @update:modelValue="(value) => (organizationId = value)"
      />
      <MerchantProfileFormNew
        v-if="organizationId"
        :key="organizationId"
        :organizationId="organizationId"
        @success="$emit('success')"
      />
    </div>
  </FullScreenModal>
</template>

<script>
import { FullScreenModal, SearchSelector } from "@estaly/ui";
import MerchantProfileFormNew from "@/components/merchant_profiles/MerchantProfileFormNew.vue";
import { useI18n } from "vue-i18n";

export default {
  components: {
    FullScreenModal,
    SearchSelector,
    MerchantProfileFormNew,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    organizations: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["close", "success"],
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      organizationId: null,
    };
  },
  watch: {
    open(isOpen) {
      if (!isOpen) this.organizationId = null;
    },
  },
};
</script>

<i18n src="./MerchantProfileCreateModal.i18n.json"></i18n>
